import { Image, Maybe } from 'graphql.generated';

type ImgList = {
    width: number;
    src: string;
}[];

type CardImg = {
    src: string;
    responsiveImgList: ImgList;
    alt: string;
};

const getListingImage = (image: Maybe<Image> | null | undefined): CardImg => {
    return {
        src: image?.src || '',
        alt: image?.caption || '',
        responsiveImgList:
            image?.responsiveImgList
                // Filtering to fix this issue: https://zpgltd.atlassian.net/browse/LEX-377
                ?.filter((listItem) => listItem?.width && listItem.src)
                .map((listItem) => {
                    return {
                        width: listItem?.width || 0,
                        src: listItem?.src || ''
                    };
                }) || []
    };
};

export default getListingImage;
